export const countryIds = {
  usaId: 194,
  australiaId: 103,
  canadaId: 440
};

export const countryWithStateIds = [
  countryIds.usaId,
  countryIds.australiaId,
  countryIds.canadaId
];


// WEBPACK FOOTER //
// ./src/constants/country-ids.js